module.exports = __webpack_public_path__ + "static/media/show.f62cbeec.svg";